"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateVariableMapping = void 0;
const dtos_1 = require("../dtos");
exports.TemplateVariableMapping = {
    [dtos_1.NotificationType.STUDENT_BULK_PHOTO_UPLOAD]: [
        'school_name',
        'imagesAdded',
        'imagesFound',
        'filesFound',
        'invalidFilesFormat',
        'studentsNotFound',
        'readErrors',
        'failedCounter'
    ],
    [dtos_1.NotificationType.BEHAVIOR_TRACKING]: [
        'school_group_name',
        'school_name',
        'student_first_name',
        'student_last_name',
        'historyReportTable'
    ],
    [dtos_1.NotificationType.IMPORT_NOTIFICATION]: ['school_group_name', 'school_name'],
    [dtos_1.NotificationType.PASSWORD_RESET]: [
        'student_first_name',
        'student_last_name',
        'email',
        'school_group_name',
        'school_name',
        'link'
    ],
    [dtos_1.NotificationType.USER_INVITE]: [
        'student_first_name',
        'student_last_name',
        'email',
        'school_group_name',
        'school_name',
        'link'
    ],
    [dtos_1.NotificationType.GUARDIAN_INVITE]: [
        'student_firstName',
        'student_lastName',
        'email',
        'school_group_name',
        'school_name',
        'link'
    ],
    [dtos_1.NotificationType.SECURE_DOWNLOAD]: [
        'school_group_name',
        'school_name',
        'fileDescription',
        'link'
    ],
    [dtos_1.NotificationType.BEHAVIOR_CODE_ENTRY_UPLOAD]: [
        'fileLength',
        'studentsNotFound',
        'studentsFound',
        'behaviorCodesNotFound',
        'behaviorCodesFound',
        'recordsFound',
        'error'
    ]
};
